import { Record } from 'immutable';

const RatePlanCodeReservationCountsRecord = Record({
  eventId: null,
  ratePlanCode: null,
  reservationCount: null
});

export class RatePlanCodeReservationCounts extends RatePlanCodeReservationCountsRecord {
  eventId: number;
  ratePlanCode: string;
  reservationCount: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/rate-plan-code-reservation-counts.ts